import {library, config} from '@fortawesome/fontawesome-svg-core'

// Make sure FontAwesome doesn't use inline CSS styles
// see https://fontawesome.com/docs/web/dig-deeper/security#content-security-policy
// Make sure this is before any other `fontawesome` API calls
config.autoAddCss = false;
import "../../node_modules/@fortawesome/fontawesome-svg-core/styles.css";

import {
    faAngleDown,
    faAngleUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faBan,
    faBook,
    faBookOpen,
    faCalendarAlt,
    faCalendarCheck,
    faCaretDown,
    faCaretUp,
    faCheck,
    faCheckCircle,
    faCircle,
    faClock,
    faCodeBranch,
    faCopy,
    faDatabase,
    faDoorClosed,
    faDoorOpen,
    faEnvelope,
    faExternalLinkAlt,
    faFileUpload,
    faGavel,
    faGlobe,
    faHistory,
    faIdBadge,
    faInfo,
    faInfoCircle,
    faKey,
    faLightbulb,
    faLink,
    faLock,
    faLockOpen,
    faMailBulk,
    faVoicemail,
    faPencilAlt,
    faPlaneDeparture,
    faParachuteBox,
    faPlus,
    faPlusCircle,
    faQuestion,
    faUnlock,
    faQuestionCircle,
    faSnowflake,
    faSync,
    faSearch,
    faSeedling,
    faTable,
    faTimes,
    faToolbox,
    faTrash,
    faTrashRestore,
    faUserFriends,
    faUserLock,
    faUsers,
    faUserAlt,
    faUserSecret,
    faWindowClose,
} from '@fortawesome/free-solid-svg-icons'

export function addIcons() {
    library.add(
        faAngleDown,
        faAngleUp,
        faArrowDown,
        faArrowLeft,
        faArrowRight,
        faArrowUp,
        faBan,
        faBook,
        faBookOpen,
        faCalendarAlt,
        faCalendarCheck,
        faCaretDown,
        faCaretUp,
        faCheck,
        faCheckCircle,
        faCircle,
        faClock,
        faCodeBranch,
        faCopy,
        faDatabase,
        faUnlock,
        faDoorClosed,
        faDoorOpen,
        faEnvelope,
        faExternalLinkAlt,
        faFileUpload,
        faGavel,
        faIdBadge,
        faGlobe,
        faHistory,
        faInfo,
        faInfoCircle,
        faKey,
        faLightbulb,
        faLink,
        faLock,
        faLockOpen,
        faMailBulk,
        faVoicemail,
        faParachuteBox,
        faPencilAlt,
        faPlaneDeparture,
        faPlus,
        faPlusCircle,
        faQuestion,
        faQuestionCircle,
        faSnowflake,
        faSearch,
        faSync,
        faSeedling,
        faUserAlt,
        faTable,
        faTimes,
        faToolbox,
        faTrash,
        faTrashRestore,
        faUserFriends,
        faUserLock,
        faUserSecret,
        faUsers,
        faWindowClose,
    );
}
